// extracted by mini-css-extract-plugin
module.exports = {"container":"CenteredMain_container__9Iwec"};